var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NotificationsListState',{attrs:{"hide-background":true}},[_c('wb-spinner',{staticClass:"notifications-list-loading__spinner"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }